var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timeSince(_vm.event.begin).indexOf('-') == -1)?_c('div',[_vm._v(" "+_vm._s(_vm.$store.getters.l.inDate.replace("{date}", _vm.timeSince(_vm.event.begin)))+": ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }